import {creates, hoistCmp} from '@xh/hoist/core';
import {AccountStructureTabModel} from './AccountStructureTabModel';
import {accountStructure} from './impl/AccountStructure';
import {Icon} from '@xh/hoist/icon';
import {itemDetails} from './impl/ItemDetails';
import {hframe} from '@xh/hoist/cmp/layout';
import {panel} from '@xh/hoist/desktop/cmp/panel';

export const accountStructureTab = hoistCmp.factory({
    model: creates(AccountStructureTabModel),
    render({model}) {
        return hframe(graphPanel(), detailsPanel());
    }
});

const graphPanel = hoistCmp.factory<AccountStructureTabModel>(({model}) =>
    panel(accountStructure({model: model.graphModel}))
);

const detailsPanel = hoistCmp.factory<AccountStructureTabModel>(({model}) =>
    panel({
        modelConfig: {
            defaultSize: 300,
            side: 'right',

            persistWith: {prefKey: 'accountStructureTabState', path: 'detailsPanelSize'},
            showSplitterCollapseButton: false
        },
        compactHeader: false,
        title: 'Details',
        icon: Icon.edit(),
        item: itemDetails({model: model.detailsModel})
    })
);
